(() => {
  function getCookie (name) {
    const dc = document.cookie
    const prefix = name + '='
    let begin = dc.indexOf('; ' + prefix)
    let end = 0
    if (begin === -1) {
      begin = dc.indexOf(prefix)
      if (begin !== 0) return null
    } else {
      begin += 2
      end = document.cookie.indexOf(';', begin)
      if (end === -1) {
        end = dc.length
      }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end))
  }

  const cookie = getCookie('_tracking_consent')
  if (cookie) {
    const state = JSON.parse(decodeURIComponent(cookie))

    if (!state?.con?.CMP?.a) {
      window.Shopify.customerPrivacy?.setTrackingConsent({
        "analytics": true,
        "marketing": true,
        "sale_of_data": false,
      }, () => console.log("Consent captured"));
    }
  }
})()
